import BarGraph from "./BarGraph";
import DownloadIcon from "@mui/icons-material/Download";

export default function Resume() {
  return (
    <div id='resume' className='min-h-screen flex-col text-center'>
      <div className='text-5xl font-bold py-25' data-aos={"slide-down"}>
        Skills and Certificates
      </div>
      <div className='grid grid-cols-2 gap-7 mt-7'>
        <ol class='relative border-l  border-gray-700 ml-9 mb-6'>
          <li class='mb-10' data-aos='zoom-in'>
            <span class='absolute flex items-center justify-center w-6 h-6   rounded-full -left-3 ring-8  ring-gray-900 bg-blue-900'>
              <svg
                aria-hidden='true'
                class='w-3 h-3  text-blue-300'
                fill='currentColor'
                viewBox='0 0 20 20'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fill-rule='evenodd'
                  d='M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z'
                  clip-rule='evenodd'
                ></path>
              </svg>
            </span>
            <h3 class='mb-1 text-lg font-semibold text-white'>
              Quality Assurance and Site Reliability Engineering
            </h3>
            <time class='block pt-1 pb-3  text-sm font-normal leading-none  text-gray-500'>
              Completed on July 12th, 2023
            </time>
            <p class='mb-4 text-base font-normal  text-gray-400'>
              Provides a detailed overview of fundamental cloud-native
              microservices, exploring various testing methodologies,
              illustrating the seamless integration of server and software
              testing in the real internet world.
            </p>
            <a
              href='https://bytedance.sg.feishu.cn/file/EdEEb5Xu5olhfsx36sglhjJfgEd'
              target='_blank'
              rel='noreferrer'
              class='inline-flex items-center px-4 py-2 mt-2 text-sm font-medium border rounded-lg  focus:z-10 focus:ring-4 focus:outline-none focus:text-blue-700 bg-gray-800 text-gray-400 border-gray-600 hover:text-white hover:bg-gray-700 focus:ring-gray-700'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='currentColor'
                class='w-4 h-8 mr-2'
                viewBox='0 0 16 16'
              >
                {" "}
                <path d='M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z' />{" "}
                <path d='M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z' />{" "}
              </svg>{" "}
              View Certificate
            </a>
          </li>
          <li class='mb-10' data-aos='zoom-out' data-aos-delay='700'>
            <span class='absolute flex items-center justify-center w-6 h-6 rounded-full -left-3 ring-8 ring-gray-900 bg-blue-900'>
              <svg
                aria-hidden='true'
                class='w-3 h-3 text-blue-300'
                fill='currentColor'
                viewBox='0 0 20 20'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fill-rule='evenodd'
                  d='M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z'
                  clip-rule='evenodd'
                ></path>
              </svg>
            </span>
            <h3 class='mb-1 text-lg font-semibold text-white'>
              CodeIT Advanced: Advanced Data Structures & Algorithms
            </h3>
            <time class='block mb-2 text-sm font-normal leading-none text-gray-500'>
              Completed on August 19th, 2022
            </time>
            <p class='text-base font-normal text-gray-400'>
              Learnt advanced concepts in algorithms and data structures and how
              to adopt computational thinking practices when solving problems.
            </p>
            <a
              href='https://drive.google.com/file/d/1IOcg0u9qF8Vu4vDlscHdx2xOGms6XnmM/view'
              target='_blank'
              rel='noreferrer'
              class='inline-flex items-center px-4 py-2 mt-5 text-sm font-medium border rounded-lg  focus:z-10 focus:ring-4 focus:outline-none focus:text-blue-700 bg-gray-800 text-gray-400 border-gray-600 hover:text-white hover:bg-gray-700 focus:ring-gray-700'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='currentColor'
                class='w-4 h-8 mr-2'
                viewBox='0 0 16 16'
              >
                {" "}
                <path d='M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z' />{" "}
                <path d='M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z' />{" "}
              </svg>{" "}
              View Certificate
            </a>
          </li>
          <li data-aos='zoom-in' data-aos-offset={"-15"} data-aos-delay='1300'>
            <span class='absolute flex items-center justify-center w-6 h-6 rounded-full -left-3 ring-8 ring-gray-900 bg-blue-900'>
              <svg
                aria-hidden='true'
                class='w-3 h-3 text-blue-300'
                fill='currentColor'
                viewBox='0 0 20 20'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fill-rule='evenodd'
                  d='M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z'
                  clip-rule='evenodd'
                ></path>
              </svg>
            </span>
            <h3 class='mb-1 text-lg font-semibold text-white'>
              Hackwagon Academy DS102: Data Analytics With Python
            </h3>
            <time class='block mb-2 text-sm font-normal leading-none text-gray-500'>
              Completed on December 17, 2020
            </time>
            <p class='text-base font-normal text-gray-400'>
              Gained proficiency in data mining, visualization, and analytics,
              along with applying various models such as linear regression for
              precise predictions based on data.
            </p>
            <a
              target='_blank'
              rel='noreferrer'
              href='https://drive.google.com/file/d/19EKhNH3-fd_i7htFXaZCcvha7xqE5Gmb/view'
              class='inline-flex items-center px-4 py-2 mt-5 text-sm font-medium border rounded-lg focus:z-10 focus:ring-4 focus:outline-none focus:text-blue-700 bg-gray-800 text-gray-400 border-gray-600 hover:text-white hover:bg-gray-700 focus:ring-gray-700'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='currentColor'
                class='w-4 h-8 mr-2'
                viewBox='0 0 16 16'
              >
                {" "}
                <path d='M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z' />{" "}
                <path d='M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z' />{" "}
              </svg>{" "}
              View Certificate
            </a>
          </li>
        </ol>

        <div className='flex flex-col text-center' data-aos='slide-up'>
          <div className='text-3xl font-bold py-3'>My Skills</div>
          <div className='ml-16 flex flex-col gap-8 mt-6'>
            <BarGraph name={"JavaScript"} percent={80} />
            <BarGraph name={"React"} percent={70} />
            <BarGraph name={"PHP"} percent={80} />
            <BarGraph name={"TypeScript"} percent={60} />
            <BarGraph name={"Java"} percent={80} />
            <BarGraph name={"HTML/CSS"} percent={85} />
            <BarGraph name={"SQL"} percent={65} />
          </div>

          <a
            href={require("../../assets/files/brendontan_resume.pdf")}
            download={"Brendon_Resume"}
            class='inline-flex items-center px-6 py-2 mt-12 mx-auto w-fit text-sm font-medium border rounded-lg  focus:z-10 focus:ring-4 focus:outline-none focus:text-blue-700 bg-gray-800 text-gray-400 border-gray-600 hover:text-white hover:bg-gray-700 focus:ring-gray-700'
          >
            Download CV <DownloadIcon />
          </a>
        </div>
      </div>
    </div>
  );
}
